<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card class="content-card">

<div fxLayout="row" style="">
  <div fxFlex="40">
    <span (click)="returnBack()" style="cursor: pointer; margin-right: 15px;">◀️ Go back</span>

    <button mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="isLoading || !prevNextIds?.prevId" (click)="gotoPrev()">&lt; Prev</button>
    <button mat-raised-button color="primary" [disabled]="isLoading || !prevNextIds?.nextId" (click)="gotoNext()">&gt; Next</button>


  </div>
  <div fxFlex="40" class="text-center" style="text-align: center;">
    <ng-container *ngIf="bankTransferLoad">
      <span style="display: inline-block; background-color: #fc5c5c; border-radius: 3px; padding: 2px 5px; margin: 0 5px; " *ngIf="bankTransferLoad.isMarkedForRefund && !bankTransferLoad.isRefunded">Marked for refund</span>
      <span style="display: inline-block; background-color: #ff1f1f; border-radius: 3px; padding: 2px 5px; margin: 0 5px; " *ngIf="bankTransferLoad.isMarkedForRefund && bankTransferLoad.isRefunded">Refunded</span>

      <span style="display: inline-block; background-color: orange; border-radius: 3px; padding: 2px 5px; margin: 0 5px; " *ngIf="(!bankTransferLoad.isMarkedForRefund) && (!bankTransferLoad.isExported || !bankTransferLoad.isConfirmed) && !bankTransferLoad.isPreApprovedManually && !bankTransferLoad.isDeclinedManually">Pending</span>
      <span style="display: inline-block; background-color: orangered; color: white; border-radius: 3px; padding: 2px 5px; margin: 0 5px; " *ngIf="(!bankTransferLoad.isMarkedForRefund) && (!bankTransferLoad.isExported || !bankTransferLoad.isConfirmed) && !bankTransferLoad.isPreApprovedManually && bankTransferLoad.isDeclinedManually">Declined</span>
      <span style="display: inline-block; background-color: purple; color: white; border-radius: 3px; padding: 2px 5px; margin: 0 5px;" *ngIf="(!bankTransferLoad.isMarkedForRefund) && (!bankTransferLoad.isExported || !bankTransferLoad.isConfirmed) && bankTransferLoad.isPreApprovedManually && !bankTransferLoad.isApprovedManually">Needs second approval</span>
      <span style="display: inline-block; background-color: #420080; color: white; border-radius: 3px; padding: 2px 5px; margin: 0 5px;" *ngIf="(!bankTransferLoad.isMarkedForRefund) && (!bankTransferLoad.isExported || !bankTransferLoad.isConfirmed) && bankTransferLoad.isPreApprovedManually && bankTransferLoad.isApprovedManually">Has second approval</span>

      <span style="display: inline-block; background-color: orange; color: black; border-radius: 3px; padding: 2px 5px; margin: 0 5px;" *ngIf="isDelayedNow && bankTransferLoad.delayedIndefinitely">Delayed indefinitely</span>
      <span style="display: inline-block; background-color: lightgray; color: black; border-radius: 3px; padding: 2px 5px; margin: 0 5px;" *ngIf="isDelayedNow && bankTransferLoad.delayNextLoadUntil">Delayed until {{ bankTransferLoad.delayNextLoadUntil | date : 'yyyy-MM-dd' }}</span>
      <span style="display: inline-block; background-color: lightgray; color: black; border-radius: 3px; padding: 2px 5px; margin: 0 5px;" *ngIf="cannotExecuteYet">Not executing before {{ bankTransferLoad.executionNotBefore | date : 'yyyy-MM-dd HH:mm' }}</span>


      <span style="display: inline-block; background-color: lightskyblue; border-radius: 3px; padding: 2px 5px; margin: 0 5px; " *ngIf="bankTransferLoad.isExported && !bankTransferLoad.isConfirmed">Exported</span>
      <span style="display: inline-block; background-color: lightskyblue; border-radius: 3px; padding: 2px 5px; margin: 0 5px; " *ngIf="bankTransferLoad.isConfirmed">Confirmed</span>

    </ng-container>
  </div>
  <div fxFlex="40" class="text-right">

    <div style="margin-top: 5px;">

    <ng-container *ngIf="!isBusy">
      <span *ngIf="bankTransferLoad?.card">

        <ng-container *ngIf="currentGpsStatus != null">

                <span *ngIf="currentGpsStatus == gpsCardStatus.AllGood">🟢 All Good</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.ReferToCardIssuer">🟡 Refer to card issuer</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.CardNotYetActivated">🟡 Card not yet activated</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.CaptureCard">🔴 Capture card</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.DoNotHonour">🔴 Do not honour</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.InvalidCard">🔴 Invalid card</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.LostCard">🟡 Lost card</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.StolenCard">🟠 Stolen card</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.ClosedAccount">⚫️ Closed Account</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.ExpiredCard">⚪️ Expired card</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.TransactionNotPermittedToCardholder">🟡 Transaction not permitted to cardholder</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.SuspectedFraud">🔴 Suspected fraud</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.RestrictedCard">🔴 Restricted card</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.SecurityViolation">🔴 Security violation</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.CardholderToContactIssuer">🔴 Cardholder to contact issuer</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.AllowableNumberOfPinTriesExceeded">Allowable number of PIN tries exceeded</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.CardDestroyed">🔴 Card destroyed</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.RefundGivenToCustomer">🔴 Refund given to customer</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.CardVoided">⚫️ Card voided</span>

                <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermBlock">🟡 Short Term Block</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermFullBlock">🟡 Short Term Full Block</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermBlock">🟠 Long Term Block</span>
                <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermFullBlock">🟠 Long Term Full Block</span>

              </ng-container>

        💳 <a routerLink="/cards/{{ bankTransferLoad.card.id }}">{{ bankTransferLoad.card.token }}</a>
      </span>
      <span *ngIf="customer" style="margin-left: 15px; margin-right: 15px;">
        <a routerLink="/customers-overview/{{ customer.id }}">{{ customer.firstName }} {{ customer.lastName }}</a>
      </span>

      <ng-container *ngIf="bankTransferLoad">

        <ng-template #manualLoad>
          ⏳ Manual
        </ng-template>
        <span style="display: inline-block; background-color: yellow; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em" *ngIf="bankTransferLoad.isInstantLoad && bankTransferLoad.isApprovedAutomatically; else manualLoad">
        ⚡️Instant
      </span>

      </ng-container>

    <!--<a [disabled]="isLoading || isBusy" mat-raised-button color="blue" routerLink="edit" *ngIf="isAdmin()">
      <mat-icon>edit</mat-icon>
      Edit
    </a>-->
    </ng-container>

    </div>

  </div>
</div>

</mat-card>

<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" *ngIf="bankTransferLoad?.hadError || bankTransferLoad?.lastErrorDescription">
  <div fxFlex="100">

    <mat-card class="content-card" style="background-color: red; color: white; padding: 15px; vertical-align: middle;">

    <p><mat-icon>warning</mat-icon> WARNING: An error occured on the last attempt to load the card: <span style="font-style: italic; font-family: monospace;">{{ bankTransferLoad.lastErrorDescription }}</span></p>
    <p>Before executing this load, check in Smart Client if the amount was not already loaded.</p>
    <p>In doubt, contact IT.</p>
    </mat-card>

  </div>
</div>

<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="50">


    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>
              <div>
              <ng-container *ngIf="bankTransferLoad && bankTransferLoad.loadType == 1">💰 Bank transfer load</ng-container>
              <ng-container *ngIf="bankTransferLoad && bankTransferLoad.loadType == 2">💰 Partner load</ng-container>
              <ng-container *ngIf="!bankTransferLoad">💰 <mat-progress-bar mode="indeterminate"></mat-progress-bar> </ng-container>
              </div>
            </h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="text-right w-100" *ngIf="bankTransferLoad">
            <div style="margin-top: 5px;">
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.GlobalWhiteListedThirdParty)" class="btl-risk-badge" style="background-color: royalblue; color: white;">Globally White-Listed</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.WhiteListedThirdParty)" class="btl-risk-badge" style="background-color: dodgerblue">White-Listed 3rd Party</span>

              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.ThirdPartyLoad) || bankTransferLoad.isThirdPartyLoad" class="btl-risk-badge" style="background-color: orangered">THIRD-PARTY</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.NoPoa)" class="btl-risk-badge" style="background-color: yellow">POA</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.MinAmountSubceeded)" class="btl-risk-badge" style="background-color: orange">Min. Amount</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.FrequencyExceeded)" class="btl-risk-badge" style="background-color: orange">Frequency</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.LimitExceeded)" class="btl-risk-badge" style="background-color: orange">Limit</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.RiskDeterminationError)" class="btl-risk-badge" style="background-color: black; color: white;">Risk Determination Error</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.InvalidCardStatus)" class="btl-risk-badge" style="background-color: orange;">Card Status</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.NeedsPreApproval)" class="btl-risk-badge" style="background-color: mediumpurple;">4-eyes</span>
              <span *ngIf="hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.ManualHold)" class="btl-risk-badge" style="background-color: coral;">Manual Hold</span>
            </div>
          </div>

          <div style="margin-bottom: 10px; border-radius: 5px; background-color: orange;" *ngIf="bankTransferLoad && bankTransferLoad.sourceRiskType == bankTransferLoadSourceRiskType.elevated">
            ELEVATED RISK SOURCE
          </div>
          <div style="margin-bottom: 10px; border-radius: 5px; background-color: orangered;" *ngIf="bankTransferLoad && bankTransferLoad.sourceRiskType == bankTransferLoadSourceRiskType.high">
            HIGH RISK SOURCE
          </div>
          <div style="margin-bottom: 10px; border-radius: 5px; background-color: red; color: white;" *ngIf="bankTransferLoad && bankTransferLoad.sourceRiskType == bankTransferLoadSourceRiskType.veryHigh">
            VERY HIGH RISK SOURCE
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Created</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ this.datePipe.transform(bankTransferLoad.createDate, 'dd.MM.yyyy HH:mm') }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Statement Date</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ this.datePipe.transform(bankTransferLoad.statementDate, "dd.MM.yyyy") }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Amount</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ bankTransferLoad.amount.formatMoneyCcy(bankTransferLoad.currencyCode) }}</label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Load fee</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ bankTransferLoad.loadFee.formatMoneyCcy(bankTransferLoad.currencyCode) }}</label>
          </div>
          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && (bankTransferLoad.amountToLoad != bankTransferLoad.amount)">
            <label fxFlex="35" class="secondary">Amount to load</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">{{ bankTransferLoad.amountToLoad.formatMoneyCcy(bankTransferLoad.currencyCode) }}</label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.amountAlreadyLoaded">
            <label fxFlex="35" class="secondary">Amount already loaded</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <ng-container *ngIf="bankTransferLoad.amountAlreadyLoaded > 0; else notYetLoaded">
                {{ bankTransferLoad.amountAlreadyLoaded.formatMoneyCcy(bankTransferLoad.currencyCode) }}
              </ng-container>
              <ng-template #notYetLoaded>
                -
              </ng-template>
            </label>
          </div>
          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.amountAlreadyLoaded && bankTransferLoad.amountToLoad > bankTransferLoad.amountAlreadyLoaded">
            <label fxFlex="35" class="secondary">Amount left to load</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <ng-container *ngIf="bankTransferLoad.amountAlreadyLoaded > 0; else notYetLoaded">
                {{ (bankTransferLoad.amountToLoad - bankTransferLoad.amountAlreadyLoaded).formatMoneyCcy(bankTransferLoad.currencyCode) }}
              </ng-container>
              <ng-template #notYetLoaded>
                {{ bankTransferLoad.amountToLoad.formatMoneyCcy(bankTransferLoad.currencyCode) }}
              </ng-template>
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.delayedIndefinitely">
            <label fxFlex="35" class="secondary">Next Load delayed</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              indefinitely
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.delayNextLoadUntil">
            <label fxFlex="35" class="secondary">Next Load delayed until</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <ng-container *ngIf="bankTransferLoad.delayNextLoadUntil; else noDelay">
                {{ bankTransferLoad.delayNextLoadUntil | date: "dd.MM.yyyy HH:mm" }}
              </ng-container>
              <ng-template #noDelay>
                -
              </ng-template>
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.executionNotBefore">
            <label fxFlex="35" class="secondary">No Execution before</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <ng-container *ngIf="bankTransferLoad.executionNotBefore; else noDelay">
                {{ bankTransferLoad.executionNotBefore | date: "dd.MM.yyyy HH:mm" }}
              </ng-container>
              <ng-template #noDelay>
                -
              </ng-template>
            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">💳 Card</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">

              <div>
              <span *ngIf="bankTransferLoad?.card?.productKey == 'kingplus' || bankTransferLoad?.card?.productKey == 'kingplus_mw' || bankTransferLoad?.card?.productKey == 'kingplus_wdl'" style="border-radius: 3px; background-color: black; color: white; padding: 1px 3px;">k+</span>
              <span *ngIf="bankTransferLoad?.card?.productKey == 'kingplus_retro' || bankTransferLoad?.card?.productKey == 'kingplus_retro_mw' || bankTransferLoad?.card?.productKey == 'kingplus_retro_wdl'" style="border-radius: 3px; background-color: #3f3a39; color: white; padding: 3px;">Retro</span>
              <span *ngIf="bankTransferLoad?.card?.isVirtualOnly" style="border-radius: 3px; background-color: #bbe4fd; padding: 3px;">V</span>
              <span *ngIf="bankTransferLoad?.card?.productKey == 'kingplus_metal' || bankTransferLoad?.card?.productKey == 'kingplus_metal_mw' || bankTransferLoad?.card?.productKey == 'kingplus_metal_wdl'" style="border-radius: 3px; background-color: #525252; color: white; padding: 3px;">Metal</span>

                {{ bankTransferLoad.card?.token }} / *{{ last4(bankTransferLoad.card?.maskedPAN) }}</div>
              <div style="margin-top: 4px;">{{ bankTransferLoad.card?.productInternalName }}</div>
            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Execution</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <ng-template #manualLoad1>
                <ng-template #manualLoad2>
                  ⏳ Manual
                </ng-template>
                <ng-container *ngIf="bankTransferLoad.isInstantLoad && !bankTransferLoad.isApprovedAutomatically; else manualLoad2">
                  ⏯ Instant but needs approval
                </ng-container>

              </ng-template>

              <ng-container *ngIf="bankTransferLoad.isInstantLoad && bankTransferLoad.isApprovedAutomatically; else manualLoad1">
                ⚡️Instant
              </ng-container>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && instantLoadDelayedUntilMoment && instantLoadDelayedUntilMoment.isAfter(now) ">
            <label fxFlex="35" class="secondary">Instant Load delayed</label>
            <label fxFlex="65">🕑 Yes, until {{ this.datePipe.transform(bankTransferLoad.instantLoadDelayedUntil, 'dd.MM.yyyy HH:mm') }}</label>

          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">
              Risk<br />
              <br />
              <button [disabled]="isLoading || isBusy || (bankTransferLoad && bankTransferLoad.isExported) || (bankTransferLoad && bankTransferLoad.card == null)" mat-icon-button color="blue" (click)="recalcLoad()" *ngIf="bankTransferLoad && !bankTransferLoad.isExported && (permissionRecalc())">
                <mat-icon>sync</mat-icon>
              </button>

            </label>
            <label fxFlex="65" *ngIf="bankTransferLoad">
              <div *ngIf="bankTransferLoad.riskLevel === 0" style="background-color: forestgreen; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Low</div>
              <div *ngIf="bankTransferLoad.riskLevel === 1" style="background-color: orange; color: black; border-radius: 5px; font-weight: bold; padding: 4px;">Medium</div>
              <div *ngIf="bankTransferLoad.riskLevel === 2" style="background-color: red; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">High</div>
              <div *ngIf="bankTransferLoad.riskLevel === 99" style="background-color: black; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Unknown</div>

              <hr />

              <ng-container *ngIf="bankTransferLoad.riskLevelAutomaticComment">
                <div *ngFor="let cmt of bankTransferLoad.riskLevelAutomaticComment.split('\n')">
                {{cmt}}
                </div>
              </ng-container>


              <div style="font-size: 9px; margin-top: 10px;">
                (Above information valid at the time of the load)
              </div>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.needsDocs">
            <label fxFlex="35" class="secondary">Documentation needed</label>
            <label fxFlex="65">⚠️ Yes</label>
          </div>
          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.uploadLink">
            <label fxFlex="35" class="secondary">Documentation requested</label>
            <label fxFlex="65">
              ⚠️
              <ng-container *ngIf="bankTransferLoad.uploadLink.typ == 1">IDV</ng-container>
              <ng-container *ngIf="bankTransferLoad.uploadLink.typ == 2">Docs</ng-container>
              <ng-container *ngIf="bankTransferLoad.uploadLink.typ == 3">Address Change</ng-container>
              <ng-container *ngIf="bankTransferLoad.uploadLink.typ == 4">SOF Generic</ng-container>
              <ng-container *ngIf="bankTransferLoad.uploadLink.typ == 5">SOF Single</ng-container>
              <ng-container *ngIf="bankTransferLoad.uploadLink.typ == 6">Address Confirmation</ng-container>
            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Card Status</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">

              <div>
                <ng-container *ngIf="currentGpsStatus != null">

                  <span *ngIf="currentGpsStatus == gpsCardStatus.AllGood">🟢 All Good</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ReferToCardIssuer">🟡 Refer to card issuer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardNotYetActivated">🟡 Card not yet activated</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CaptureCard">🔴 Capture card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.DoNotHonour">🔴 Do not honour</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.InvalidCard">🔴 Invalid card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LostCard">🟡 Lost card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.StolenCard">🟠 Stolen card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ClosedAccount">⚫️ Closed Account</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ExpiredCard">⚪️ Expired card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.TransactionNotPermittedToCardholder">🟡 Transaction not permitted to cardholder</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.SuspectedFraud">🔴 Suspected fraud</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.RestrictedCard">🔴 Restricted card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.SecurityViolation">🔴 Security violation</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardholderToContactIssuer">🔴 Cardholder to contact issuer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.AllowableNumberOfPinTriesExceeded">Allowable number of PIN tries exceeded</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardDestroyed">🔴 Card destroyed</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.RefundGivenToCustomer">🔴 Refund given to customer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardVoided">⚫️ Card voided</span>

                  <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermBlock">🟡 Short Term Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermFullBlock">🟡 Short Term Full Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermBlock">🟠 Long Term Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermFullBlock">🟠 Long Term Full Block</span>

                </ng-container>
              </div>

            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Status</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">


              <app-load-status-info [bankTransferLoad]="bankTransferLoad" [customer]="customer"></app-load-status-info>
              <div *ngIf="bankTransferLoad.amountAlreadyLoaded > 0 && bankTransferLoad.amountAlreadyLoaded < bankTransferLoad.amountToLoad">
                <mat-icon style="color: deeppink;">call_split</mat-icon> This load is a partial load
              </div>




            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.exportedDate">
            <label fxFlex="35" class="secondary">Exported on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.exportedDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.markedForRefundDate">
            <label fxFlex="35" class="secondary">Marked for refund on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.markedForRefundDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.refundedDate">
            <label fxFlex="35" class="secondary">Refunded on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.refundedDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.confirmedDate">
            <label fxFlex="35" class="secondary">Confirmed on</label>
            <label fxFlex="65">
              {{ this.datePipe.transform(bankTransferLoad.confirmedDate, 'dd.MM.yyyy HH:mm') }}
            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Max Daily</label>
            <label fxFlex="65" *ngIf="maxDailyLoad != null && bankTransferLoad != null">
              {{ maxDailyLoad.formatMoneyCcy(bankTransferLoad.currencyCode) }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && !bankTransferLoad.isMarkedForRefund">
            <label fxFlex="35" class="secondary">Ident/Docs</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">

              <div class="mb-dot5 mr-1 inline-block">
                <button [class.spinner]="_isSendingSofSingle" [disabled]="isLoading || _isSendingSofSingle || isBusy || bankTransferLoad.isDocsRequested || (bankTransferLoad && (bankTransferLoad.isApprovedManually || (!bankTransferLoad.needsManualApproval && !bankTransferLoad.isDeclinedManually)))" mat-raised-button color="yellow" (click)="requestSof()" *ngIf="permissionRequestDocs()">
                  🧾 Request SOF
                </button>
              </div>

              <div class="mb-dot5 mr-1 inline-block">
                <button [disabled]="isLoading || _isRequestingIdent || isBusy || bankTransferLoad.isConfirmed" mat-raised-button color="yellow" (click)="requestIdent()" *ngIf="permissionRequestIdent()">
                  🔍 Request Ident
                </button>
              </div>

              <div class="mb-dot5 mr-1 inline-block">
                <button [class.spinner]="_isSendingPoa" [disabled]="isLoading || _isSendingPoa || isBusy || bankTransferLoad.isAddressConfirmationRequested || (bankTransferLoad && (bankTransferLoad.isApprovedManually || (!bankTransferLoad.needsManualApproval && !bankTransferLoad.isDeclinedManually)))" mat-raised-button color="yellow" (click)="requestPoa()" *ngIf="permissionRequestPoa()">
                  🏠 Request POA
                </button>
              </div>

            </label>
          </div>


          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && !bankTransferLoad.isMarkedForRefund">
            <label fxFlex="35" class="secondary">Approval</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">

              <button [disabled]="isLoading || isBusy || bankTransferLoad.isExported || (bankTransferLoad && (!bankTransferLoad.isApprovedManually || !bankTransferLoad.needsManualApproval) && !bankTransferLoad.isDeclinedManually)" style="margin-right: 10px;" mat-raised-button color="blue" (click)="holdLoad()" *ngIf="permissionHoldLoad()">
                <mat-icon>pause_circle_outline</mat-icon>
                Hold
              </button>

              <button [class.spinner]="isApprovingLoad" [disabled]="isLoading || isBusy || bankTransferLoad.isExported || (bankTransferLoad && (bankTransferLoad.isApprovedManually || (!bankTransferLoad.needsManualApproval && !bankTransferLoad.isDeclinedManually)))" style="margin-right: 10px;" mat-raised-button color="primary" (click)="approveLoad()" *ngIf="permissionApproveLoad()">
                🆗
                Approve
              </button>
              <button [class.spinner]="isDecliningLoad" [disabled]="isLoading || isBusy || bankTransferLoad.isExported || (bankTransferLoad && bankTransferLoad.isDeclinedManually)" style="margin-right: 20px;" mat-raised-button color="accent" (click)="declineLoad()" *ngIf="permissionDeclineLoad()">
                🚫
                Decline
              </button>

            </label>
          </div>

          <ng-container  *ngIf="bankTransferLoad && !bankTransferLoad.isMarkedForRefund">
            <div class="list-item" fxLayout="row">
              <label fxFlex="35" class="secondary">Execution</label>
              <label fxFlex="65" *ngIf="bankTransferLoad">

                <ng-container>

                  <button [class.spinner]="isExecutingLoad" [disabled]="!permissionExecuteLoad() || isExecutingLoad || isLoading ||(isBusy || bankTransferLoad.isConfirmed || bankTransferLoad.isExported || (!bankTransferLoad.isApprovedManually && bankTransferLoad.needsManualApproval) || (bankTransferLoad.isDeclinedManually) || (!bankTransferLoad.isApprovedAutomatically && !bankTransferLoad.isApprovedManually))" style="margin-right: 10px;" mat-raised-button color="primary" (click)="executeLoad()" *ngIf="(isAdmin() || isCompliance()) && currentGpsStatus != 'G3'">
                    <ng-container style="color: red;" *ngIf="bankTransferLoad?.hadError || bankTransferLoad?.lastErrorDescription"><mat-icon style="color: red;">warning</mat-icon></ng-container>
                    <ng-container *ngIf="!bankTransferLoad?.hadError && !bankTransferLoad?.lastErrorDescription"><mat-icon>credit_card</mat-icon></ng-container>

                    Execute Load
                  </button>


                  <button [class.spinner]="isExecutingLoad" [disabled]="!permissionExecuteLoad() || isExecutingLoad || isLoading ||(isBusy || bankTransferLoad.isConfirmed || bankTransferLoad.isExported || (!bankTransferLoad.isApprovedManually && bankTransferLoad.needsManualApproval) || (bankTransferLoad.isDeclinedManually) || (!bankTransferLoad.isApprovedAutomatically && !bankTransferLoad.isApprovedManually))" style="margin-right: 10px;" mat-raised-button color="warn" (click)="executeG3Load()" *ngIf="(isAdmin() || isCompliance()) && currentGpsStatus == 'G3'">
                    <ng-container style="color: red;" *ngIf="bankTransferLoad?.hadError || bankTransferLoad?.lastErrorDescription"><mat-icon style="color: red;">warning</mat-icon></ng-container>
                    <ng-container *ngIf="!bankTransferLoad?.hadError && !bankTransferLoad?.lastErrorDescription"><mat-icon>credit_card</mat-icon></ng-container>

                    Execute G3 Load
                  </button>

                </ng-container>

                <!-- compliance may confirm manually IF exported -->
                <button [disabled]="isLoading || isBusy || (!bankTransferLoad.isExported && !bankTransferLoad.isConfirmed) || bankTransferLoad.isMarkedForRefund || bankTransferLoad.isConfirmed" style="margin-right: 20px;" mat-raised-button color="blue" (click)="confirmLoadManually()" *ngIf="permissionConfirmIfExported() && !permissionConfirmNotExported()">
                  📝 Confirm manually
                </button>
                <!-- admins may confirm manually EVEN IF NOT exported -->
                <button [disabled]="isLoading || isBusy || bankTransferLoad.isConfirmed" style="margin-right: 20px;" mat-raised-button color="blue" (click)="confirmLoadManually()" *ngIf="permissionConfirmNotExported()">
                  📝 Confirm manually
                </button>

              </label>
            </div>
            <div class="list-item" fxLayout="row">
              <label fxFlex="35" class="secondary">Refund</label>
              <label fxFlex="65" *ngIf="bankTransferLoad">

                <!-- admins may refund -->
                <button [disabled]="isLoading || isBusy || bankTransferLoad.isConfirmed" style="margin-right: 20px;" mat-raised-button color="accent" (click)="markLoadForRefund()" *ngIf="permissionMarkForRefund()">
                  <mat-icon>money_off</mat-icon>
                  Mark for Refund
                </button>

              </label>
            </div>
          </ng-container>

          <div class="list-item" fxLayout="row" *ngIf="bankTransferLoad && bankTransferLoad.isMarkedForRefund">
            <label fxFlex="35" class="secondary">Refund</label>
            <label fxFlex="65" *ngIf="bankTransferLoad">

              <button [disabled]="isLoading || isBusy || bankTransferLoad.isRefunded" style="margin-right: 10px;" mat-raised-button color="blue" (click)="holdLoad()" *ngIf="permissionHoldLoad()">
                <mat-icon>pause_circle_outline</mat-icon>
                Back to Hold
              </button>

              <button [disabled]="isLoading || isBusy || bankTransferLoad.isRefunded" style="margin-right: 10px;" mat-raised-button color="warn" (click)="refundLoad()" *ngIf="isAdmin()">
                <mat-icon>attach_money</mat-icon>
                Mark as refunded
              </button>


            </label>
          </div>

        </mat-card-content>

      </mat-card>
    </div>

    <div style="padding-left: 10px; padding-right: 10px;" *ngIf="bankTransferLoad && bankTransferLoad.card">

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <b>Card {{ bankTransferLoad.card.token }}</b>
                <ng-container *ngIf="currentGpsStatus != '00'">⚠️</ng-container>
                <ng-container *ngIf="currentGpsStatus == '00'">🟢️</ng-container>
              </mat-panel-title>
              <mat-panel-description>
                {{ bankTransferLoad.card.productName }}, {{ bankTransferLoad.card.cardTypeName }}<br />
                {{ bankTransferLoad.card.cardName }}, {{bankTransferLoad.card.statusName}}, EXP {{ bankTransferLoad.card.expireDate | date:"MM/yy" }}

              </mat-panel-description>
            </mat-expansion-panel-header>




          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCard ">
            <label fxFlex="35" class="secondary">{{ field.header }}</label>
            <label fxFlex="65" *ngIf="bankTransferLoad && bankTransferLoad.card">{{ field.cell(bankTransferLoad.card) }}</label>
          </div>
          </mat-expansion-panel>
    </div>

    <div *ngIf="bankTransferLoad && bankTransferLoad.card">
      <div>
        <mat-card class="content-card">
          <mat-card-header style="display: inherit">
            <mat-card-title>
                <div fxFlex="50">
                  <h5>💶 Load history</h5>
                </div>
                <div fxFlex="50" style="text-align: right;">
                  <div style="font-size: .9em; font-weight: bold;">Sum Loads 1Y: {{ loadHistorySum }}</div>
                  <ng-container *ngIf="loadHistoryPendingSum > 0.1">
                    <div style="color: grey; font-size: .8em; font-weight: bold;">Pending: {{ loadHistoryPendingSum }}</div>
                  </ng-container>
                </div>


            </mat-card-title>
          </mat-card-header>
          <mat-card-content>

            <div style="margin: 5px;">
              <div style="width: 100%; height: 25px; " *ngIf="this.customerRisk">
                <div  style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: dodgerblue; height: 20px; float: left; width: {{ this.customerRisk.riskSumBankTransferLoad * 100 / this.customerRisk.riskSumLoadTotal }}%">BTL</div>
                <div style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: forestgreen; height: 20px; float: left; width: {{ this.customerRisk.riskSumLoadSofort * 100 / this.customerRisk.riskSumLoadTotal }}%">SOF</div>
                <div style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: mediumpurple; height: 20px; float: left; width: {{ this.customerRisk.riskSumLoadSepa * 100 / this.customerRisk.riskSumLoadTotal }}%">SEP</div>
                <div style="overflow: hidden; font-size: 9px; padding-top: 5px; text-align: center; vertical-align: center; background-color: orange; height: 20px; float: left; width: {{ this.customerRisk.riskSumCardToCardInbound * 100 / this.customerRisk.riskSumLoadTotal }}%">C2C</div>
              </div>
              <ng-container *ngIf="isLoadingRisk">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </ng-container>
            </div>

            <div class="list-item" fxLayout="row" fxLayoutGap="10px">
              <label fxFlex="20" class="secondary">Date</label>
              <label fxFlex="16" class="secondary">Token</label>
              <label fxFlex="16" class="secondary">Amount</label>
              <label fxFlex="15" class="secondary">Status</label>
              <label fxFlex="35" class="secondary">Risk</label>
              <label fxFlex="15" class="secondary"></label>


            </div>
            <div>
              <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let load of loadHistory" >
                <label class="" fxFlex="20" >{{ load.createDate | date: "dd.MM.yyyy" }}</label>
                <label class="" fxFlex="16" style="vertical-align: top">
                  <div style="display: inline-block"><mat-icon [ngStyle]="{fontSize: '1.2em', color: (load.loadType == 1 ? 'grey':'blue')}">{{load.loadType == 1 ? "account_balance" : "assignment_ind"}}</mat-icon></div>
                  <div style="display: inline-block; vertical-align: top">{{load.card.token}}</div>
                </label>
                <label class="" fxFlex="16" >
                  {{load.amountToLoad.formatMoneyEuro()}}
                </label>
                <label class="" fxFlex="15" >
                  <!-- load status icons -->
                  <div *ngIf="load.isConfirmed && load.amountAlreadyLoaded >= load.amountToLoad">
                    <mat-icon matTooltip="Confirmed" style="color: green">done_all</mat-icon>
                  </div>
                  <div *ngIf="load.isConfirmed && load.amountAlreadyLoaded < load.amountToLoad">
                    <mat-icon matTooltip="Confirmed partial" style="color: deeppink;">call_split</mat-icon>
                  </div>
                  <ng-container *ngIf="!load.isConfirmed">
                    <div matTooltip="Approved automatically" *ngIf="load.isApprovedAutomatically && !load.isApprovedManually && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: dodgerblue">done</mat-icon>
                    </div>
                    <div matTooltip="Approved manually" *ngIf="load.isApprovedManually && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: forestgreen">done</mat-icon>
                    </div>
                    <div  matTooltip="Declined" *ngIf="load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: red;">clear</mat-icon>
                    </div>
                    <div  matTooltip="Needs approval" *ngIf="load.needsManualApproval && !load.isApprovedManually && !load.isApprovedAutomatically && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: orange">search</mat-icon>
                    </div>
                    <div  matTooltip="Needs 2 approvals" *ngIf="load.needsManualApproval && load.needsPreApproval && !load.isApprovedManually && !load.isApprovedAutomatically && !load.isDeclinedManually && !load.isMarkedForRefund && !load.isRefunded">
                      <mat-icon style="color: purple">search</mat-icon>
                    </div>
                  </ng-container>

                  <div style="color: red;" *ngIf="load.isMarkedForRefund && !load.isRefunded">to refund</div>
                  <div style="color:red;" *ngIf="load.isMarkedForRefund && load.isRefunded">refunded</div>

                </label>
                <label class="" fxFlex="35" >
                  <span *ngIf="load.riskLevel === 0" class="btl-risk-badge" style="background-color: forestgreen; color: white;">Low</span>
                  <span *ngIf="load.riskLevel === 1" class="btl-risk-badge" style="background-color: orange; color: black;">Medium</span>
                  <span *ngIf="load.riskLevel === 2" class="btl-risk-badge" style="background-color: red; color: white;">High</span>
                  <span *ngIf="load.riskLevel === 99" class="btl-risk-badge" style="background-color: black; color: white;">Unknown</span>


                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.GlobalWhiteListedThirdParty)" class="btl-risk-badge" style="background-color: royalblue; color: white;">Globally White-Listed</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.WhiteListedThirdParty)" class="btl-risk-badge" style="background-color: dodgerblue">White-Listed</span>

                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.ThirdPartyLoad) || load.isThirdPartyLoad" class="btl-risk-badge" style="background-color: orangered">THIRD-PARTY</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.NoPoa)" class="btl-risk-badge" style="background-color: yellow">POA</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.MinAmountSubceeded)" class="btl-risk-badge" style="background-color: orange">Min. Amount</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.FrequencyExceeded)" class="btl-risk-badge" style="background-color: orange">Frequency</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.LimitExceeded)" class="btl-risk-badge" style="background-color: orange">Limit</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.RiskDeterminationError)" class="btl-risk-badge" style="background-color: black; color: white;">Risk Determination Error</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.InvalidCardStatus)" class="btl-risk-badge" style="background-color: orange;">Card Status</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.NeedsPreApproval)" class="btl-risk-badge" style="background-color: mediumpurple;">4-eyes</span>
                  <span *ngIf="hasLoadRiskFlag(load.riskFlags, loadRiskFlags.ManualHold)" class="btl-risk-badge" style="background-color: coral;">Manual Hold</span>


                  <div>
                    <small>
                      <ng-container *ngIf="load.trustPayTransaction">
                        <ng-container *ngIf="load.trustPayTransaction.counterAccountName">
                          {{ load.trustPayTransaction.counterAccountName.substr(0,40) }}<br/>
                        </ng-container>
                        {{ load.trustPayTransaction.counterAccountMasked }}
                      </ng-container>
                    </small>
                  </div>

                </label>
                <label fxFlex="15">
                  <ng-container *ngIf="load.id !== this.bankTransferLoadId">
                    <a [routerLink]="'../' + load.id">Detail</a>
                  </ng-container>
                  <ng-container *ngIf="load.id === this.bankTransferLoadId">
                    <small>(this load)</small>
                  </ng-container>

                </label>
              </div>
            </div>
            <ng-container *ngIf="sofortHistory && sofortHistory.length > 0">
              <div style="margin-left: 10px;">
                  <h5>Sofort history</h5>
              </div>

              <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
                <label fxFlex="20" class="secondary">Date</label>
                <label fxFlex="16" class="secondary">Amount</label>
                <label fxFlex="15" class="secondary">Status</label>
                <label fxFlex="35" class="secondary">Risk</label>
              </div>
              <div>
                <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let load of sofortHistory" >
                  <label class="" fxFlex="20" >
                    <span *ngIf="load.statementDate">{{ load.statementDate | date: "dd.MM.yyyy" }}</span>
                    <span style="color: red;" *ngIf="!load.statementDate && load.transactionCreatedDate">{{ load.transactionCreatedDate | date: "dd.MM.yyyy" }} <mat-icon>assignment_late</mat-icon></span>
                  </label>
                  <label class="" fxFlex="16" >

                    <span *ngIf="load.statementAmount">{{ load.statementAmount.formatMoneyEuro() }}</span>
                    <span style="color: red;" *ngIf="!load.statementAmount && load.transactionAmount">{{ load.transactionAmount.formatMoneyEuro() }} <mat-icon>assignment_late</mat-icon></span>
                  </label>
                  <label class="" fxFlex="15" >

                  </label>
                  <label class="" fxFlex="35" >

                  </label>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sepaHistory && sepaHistory.length > 0">
              <div style="margin-left: 10px;">
                <h5>SEPA History</h5>
              </div>

              <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
                <label fxFlex="20" class="secondary">Date</label>
                <label fxFlex="16" class="secondary">Amount</label>
                <label fxFlex="15" class="secondary">Status</label>
                <label fxFlex="35" class="secondary">Risk</label>

              </div>
              <div>
                <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let load of sepaHistory" >
                  <label class="" fxFlex="20" ><span *ngIf="load?.date">{{ load.date | date: "dd.MM.yyyy" }}</span></label>
                  <label class="" fxFlex="16" >
                    {{load.amount?.formatMoneyEuro()}}
                  </label>
                  <label class="" fxFlex="15" >

                  </label>
                  <label class="" fxFlex="35" >

                  </label>
                </div>
              </div>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>

  <div fxFlex="50">


    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>📥 Inbound Transaction</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoading || trustPayTransaction">
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsTransaction ">
            <label fxFlex="35" class="secondary">{{ field.header }}</label>
            <label fxFlex="65" *ngIf="trustPayTransaction">{{ field.cell(trustPayTransaction) }}</label>
          </div>
          </ng-container>
          <ng-container *ngIf="!isLoading && !trustPayTransaction">
            <div style="margin-left: 15px;">(no transaction)</div>
          </ng-container>
        </mat-card-content>
        <mat-card-actions align="start">

          <div class="w-100" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
            <div fxFlex="50" style="padding-left: 10px;">
              <div *ngIf="bankTransferLoad && hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.GlobalWhiteListedThirdParty)" style="color: #333; background-color: lightgray; border-radius: 3px; padding: 2px;">👍 This is a globally white-listed sender</div>
              <button color="purple" *ngIf="!(bankTransferLoad && hasLoadRiskFlag(bankTransferLoad.riskFlags, loadRiskFlags.GlobalWhiteListedThirdParty)) && (isLoading || trustPayTransaction) && isCompliance() && bankTransferLoad?.card != null" [disabled]="isLoading || (trustPayTransaction == null) || !trustPayTransaction.counterAccountName" mat-raised-button (click)="globallyWhiteListBankAccount()">👍 Globally White-List this sender</button>
            </div>
            <div fxFlex="50" class="text-right" style="padding-right: 10px;">
              <button *ngIf="(isLoading || trustPayTransaction) && isAdmin() && bankTransferLoad?.card != null" [disabled]="isLoading || (trustPayTransaction == null) || (bankTransferLoad != null && bankTransferLoad.isExported)" mat-raised-button (click)="unlinkTransactionFromBtl()"><mat-icon>delete</mat-icon> Unlink this transaction and delete load</button>
            </div>
          </div>




        </mat-card-actions>
      </mat-card>
    </div>

    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>📤 Outbound Transactions</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ng-container *ngIf="isLoading || outboundTransactions">
              <mat-table [dataSource]="outboundTransactions">
                <ng-container matColumnDef="transactionDate">
                  <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
                  <mat-cell *matCellDef="let txn"> {{ txn.transactionDate | date : 'dd.MM.yyyy HH:mm' }}  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="type">
                  <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
                  <mat-cell *matCellDef="let txn"><span *ngIf="txn.type === 1">WebService</span><span *ngIf="txn.type === 2">CSV</span></mat-cell>
                </ng-container>
                <ng-container matColumnDef="amountLoaded">
                  <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                  <mat-cell *matCellDef="let txn"> {{txn.amountLoaded}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="status">
                  <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                  <mat-cell *matCellDef="let txn">{{txn.lastGpsStatus}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="info">
                  <mat-header-cell *matHeaderCellDef>Info</mat-header-cell>
                  <mat-cell *matCellDef="let txn">
                      <span *ngIf="txn.lastGpsStatus && txn.lastGpsStatus == '000'" style="font-size: .8em; padding: 2px; border-radius: 3px; background-color: forestgreen; font-family: monospace;">OK</span>
                      <span *ngIf="txn.lastGpsStatus && txn.lastGpsStatus == '123'" style="font-size: .8em; padding: 2px; border-radius: 3px; background-color: orange; font-family: monospace;">Frequency limits exceeded, deny</span>
                      <span *ngIf="txn.lastGpsStatus && txn.lastGpsStatus == '121'" style="font-size: .8em;  padding: 2px; border-radius: 3px; background-color: orange; font-family: monospace;">Amount limits exceeded or outside valid load range</span>
                  </mat-cell>
                </ng-container>

                <!-- Header and Row Declarations -->
                <mat-header-row *matHeaderRowDef="['transactionDate', 'type', 'amountLoaded', 'status', 'info']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['transactionDate', 'type', 'amountLoaded', 'status', 'info']"></mat-row>
              </mat-table>

          </ng-container>
        </mat-card-content>
      </mat-card>
    </div>

    <div>

      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Self-Load Determination</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>



          <ng-container *ngIf="isLoadingSelfLoadDetermination">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>

          <ng-container *ngIf="selfLoadDetermination">

            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label class="" fxFlex="30" >Self Load Score</label>

              <label class="" fxFlex="30" >

              <ng-container *ngIf="selfLoadDetermination.selfLoadScore >= .85">🟢⚪️⚪️⚪️</ng-container>
              <ng-container *ngIf="selfLoadDetermination.selfLoadScore < .85 && selfLoadDetermination.selfLoadScore >= .70">⚪️🟡⚪️⚪️</ng-container>
              <ng-container *ngIf="selfLoadDetermination.selfLoadScore < .70 && selfLoadDetermination.selfLoadScore >= .60">⚪️⚪️🟠⚪️</ng-container>
              <ng-container *ngIf="selfLoadDetermination.selfLoadScore < .60">⚪️⚪️⚪️🔴</ng-container>


              </label>
              <label class="" fxFlex="40" >{{ selfLoadDetermination.selfLoadScore * 100}} of 100</label>
            </div>

            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label class="" fxFlex="30" >Account Name Confidence</label>

              <label class="" fxFlex="30" >
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.confidence >= .85">🟢⚪️⚪️⚪️</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.confidence < .85 && selfLoadDetermination.accountNameInfo.confidence >= .70">⚪️🟡⚪️⚪️</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.confidence < .70 && selfLoadDetermination.accountNameInfo.confidence >= .60">⚪️⚪️🟠⚪️</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.confidence < .60">⚪️⚪️⚪️🔴</ng-container>


              </label>
              <label class="" fxFlex="40" >{{ selfLoadDetermination.accountNameInfo.confidence * 100}} of 100</label>
            </div>

            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label class="" fxFlex="30" >Account Type</label>
              <label class="" fxFlex="70" >
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.accountType == 99">Unknown</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.accountType == 1">Personal</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.accountType == 2">Business</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.accountType == 3">Government</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.accountType == 4">Insurance</ng-container>
                <ng-container *ngIf="selfLoadDetermination.accountNameInfo.accountType == 20">Joint Account</ng-container>
              </label>
            </div>
            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label class="" fxFlex="30" >First names account</label>
              <label class="" fxFlex="70" >{{ selfLoadDetermination.accountNameInfo.firstNames.join(', ') }}</label>
            </div>
            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label class="" fxFlex="30" >Last names account</label>
              <label class="" fxFlex="70" >{{ selfLoadDetermination.accountNameInfo.lastNames.join(', ') }}</label>
            </div>

            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label class="" fxFlex="30" >First names customer</label>
              <label class="" fxFlex="70" >{{ selfLoadDetermination.firstNamesLastNames.firstNames.join(', ') }}</label>
            </div>
            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label class="" fxFlex="30" >Last names customer</label>
              <label class="" fxFlex="70" >{{ selfLoadDetermination.firstNamesLastNames.lastNames.join(', ') }}</label>
            </div>


          </ng-container>

        </mat-card-content>
      </mat-card>



    </div>

    <div>
      <ng-container *ngIf="isLoadingWhiteListedBankAccounts">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <app-customer-whitelisted-bankaccounts-view [whiteListedBankAccounts]="whiteListedBankAccounts" class="mt-2"></app-customer-whitelisted-bankaccounts-view>
    </div>


    <div style="margin-left: 10px; margin-right: 10px;" class="smsPushFormContainer">
      <mat-expansion-panel *appHasRoles="['admin', 'manager', 'agent', 'compliance']">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>
              📱 Send Message
              <span style="display: inline-block; background-color: #9a9a9a; border-radius: 3px; padding: 2px 5px; margin: 0 5px; font-size: .8em" *ngIf="smsEmailLogs && smsEmailLogs.length > 0">
                {{smsEmailLogs.length}}
              </span>
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="bankTransferLoad && bankTransferLoad.card">




              <mat-tab-group *appHasRoles="['admin', 'manager', 'agent', 'compliance']">
                <mat-tab label="📱 Send SMS">


                  <!-- (ngSubmit)="onSendSms(smsForm)" -->
                  <form *ngIf="smsForm" [formGroup]="smsForm" class="content-card" >
                    <mat-form-field >
                      <input matInput placeholder="Mobile" formControlName="mobile" [disabled]="true" [readonly]="true" [imask]="phoneMask" [unmask]="true" minlength="10" maxlength="15">
                    </mat-form-field>
                    <mat-form-field>
                      <textarea rows="6" matInput placeholder="Message" formControlName="message" #textareamessage required></textarea>
                    </mat-form-field>
                    <span *ngIf="smsForm?.controls['message']?.value?.length > 160" style="color: red;">
              ~ {{ smsForm?.controls['message']?.value?.length }}
            </span>
                    <span *ngIf="smsForm?.controls['message']?.value?.length <= 160" style="color: green;">
              ~ {{ smsForm?.controls['message']?.value?.length }}
            </span>
                    <span>
              &nbsp;/&nbsp; 160 &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
                  </form>

                  <mat-card-actions>
                    <button mat-raised-button color="primary" type="submit" *ngIf="smsForm?.controls['mobile']?.value != null" [disabled]="(smsForm?.controls['message']?.value?.trim().length < 1) || isSmsSending" (click)="onSendSms(smsForm)">Send SMS</button>
                  </mat-card-actions>
                </mat-tab>
                <mat-tab label="📱 Push Notification">
                  <form *ngIf="pushForm" [formGroup]="pushForm" class="content-card" >
                    <div>
                      <mat-checkbox formControlName="isSilent">Silent message</mat-checkbox>
                    </div>
                    <ng-container *ngIf="pushForm.get('isSilent').value == false">
                      <div>
                        <small>Notification</small>
                      </div>
                      <mat-form-field>
                        <input matInput placeholder="Notification Title" formControlName="notificationTitle">
                      </mat-form-field>
                      <mat-form-field>
                        <input matInput placeholder="Notification Text" formControlName="notificationText">
                      </mat-form-field>

                      <mat-form-field>
                        <mat-select placeholder="Severity" formControlName="severity">
                          <mat-option value="success">Success</mat-option>
                          <mat-option value="info" selected>Info</mat-option>
                          <mat-option value="warn">Warning</mat-option>
                          <mat-option value="error">Error</mat-option>
                        </mat-select>
                      </mat-form-field>

                      <div>
                        <small>Body (when user taps on notification)</small>
                      </div>
                      <mat-form-field>
                        <input matInput placeholder="Body Title" formControlName="bodyTitle">
                      </mat-form-field>
                      <mat-form-field>
                        <textarea rows="6" matInput placeholder="Body Text" formControlName="bodyText"></textarea>
                      </mat-form-field>
                    </ng-container>

                    <mat-form-field>
                      <textarea rows="6" matInput placeholder="Data" formControlName="dataString"></textarea>
                    </mat-form-field>

                  </form>

                  <mat-card-actions>
                    <button mat-raised-button color="primary" type="submit" [disabled]="isPushSending" (click)="onSendPush(pushForm)">Send Push</button>
                  </mat-card-actions>

                </mat-tab>

              </mat-tab-group>


            <app-customer-email-log-view *ngIf="customer && smsEmailLogs && smsEmailLogs.length > 0" [logs]="smsEmailLogs"></app-customer-email-log-view>

          <!--<div style="margin-top: 20px;">
            <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
              <label fxFlex="20" class="secondary">Date</label>
              <label fxFlex="16" class="secondary">Type</label>
              <label fxFlex="15" class="secondary">User</label>
              <label fxFlex="35" class="secondary">Mobile</label>
              <label fxFlex="15" class="secondary">Message</label>


            </div>
            <div id="scroll">
              <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let log of smsEmailLogs" >
                <label class="" fxFlex="20" >{{ log.creationDate | date: "dd.MM.yyyy HH:mm" }}</label>
                <label class="" fxFlex="16" >
                  {{ log.emailType == 15 ? 'Manual SMS' : '' }}
                  {{ log.emailType == 18 ? 'Manual Push' : '' }}
                  {{ log.emailType == 19 ? 'Address Confirmation' : '' }}
                  {{ log.emailType == 20 ? 'Automatic Push' : '' }}
                </label>
                <label class="" fxFlex="15" >{{ log.creator == null ? 'System' : log.creator.firstName }} {{ log.creator == null ? '' : log.creator.lastName }}</label>
                <label class="" fxFlex="35" >{{ log.emailAddress }}</label>
                <label class="" fxFlex="15" >{{ log.comment }}</label>
              </div>
            </div>
          </div>
          <div *ngIf="bankTransferLoad && bankTransferLoad.card == null">
            (no card assigned)
          </div>
          < !--<app-customer-email-log-view *ngIf="customer && smsEmailLogs && smsEmailLogs.length > 0" [logs]="smsEmailLogs" [header]="'Manual SMS logs'" class="mt-2"></app-customer-email-log-view>-->

        </div>

      </mat-expansion-panel>
    </div>


    <app-object-comments-view class="mt-2" caption="Comments" *ngIf="comments" [comments]="comments" [objectId]="bankTransferLoadId" [target]="commentsTarget"></app-object-comments-view>


    <div *ngIf="bankTransferLoad?.card" style="margin-left: 10px; margin-right: 10px;">

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>


            <app-customer-badges *ngIf="customer" [customer]="customer"></app-customer-badges>


            <ng-container *ngIf="customer && customer.sex == 'm'">👦</ng-container><ng-container *ngIf="customer && customer.sex == 'f'">👩</ng-container> Customer<ng-container *ngIf="customer">: {{customer.firstName}} {{customer.lastName|uppercase}}</ng-container>

            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="customer">
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCustomer ">
            <app-content-row [field]="field" [entity]="customer"></app-content-row>
          </div>
        </ng-container>
        <ng-container *ngIf="!customer">
          <div style="margin-left: 15px;">(no customer assigned)</div>
        </ng-container>
      </mat-expansion-panel>

    </div>

    <app-event-log-view [logs]="logs" *ngIf="isAdmin()"></app-event-log-view>

    <div style="" class="content-card full-card">
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>
            <h5>🔮 Card Processor Enquiry</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-expansion-panel disabled=true>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Card
              </mat-panel-title>
              <mat-panel-title>
                Token
              </mat-panel-title>
              <mat-panel-title>
                Expiry date
              </mat-panel-title>
              <mat-panel-title>
                Status
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel *ngFor="let card of cards">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{card.card.product.shortName}}
              </mat-panel-title>
              <mat-panel-title>
                {{card.card.token}}
              </mat-panel-title>
              <mat-panel-title>
                {{card.card.expireDate | date: 'MM/yy'}}
              </mat-panel-title>
              <mat-panel-title class="{{card.card.status == 6 ? 'warning-row' : ''}}">
                {{card.card.statusName}}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <button mat-raised-button color="primary" (click)="getStatement(card)" [disabled]="!isGpsButtonEnabled()" style="margin-right: 10px;">Get statement</button>
            <button mat-raised-button color="primary" (click)="getCardholderDetails(card)" [disabled]="!isGpsButtonEnabled()" style="margin-right: 10px;">Get cardholder details</button>
            <button mat-raised-button color="primary" (click)="getCardInfos(card)" [disabled]="!isGpsButtonEnabled()">Get card infos</button>

            <small style="color: red; margin-left: 20px;">Enquiries will be logged!</small>



            <div [hidden]="!isStatementLoading" style="margin-top: 10px;">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>

            <div *ngIf="card.statement && card.statement.financialTransactions" style="margin-top: 10px;" class="statement">
              <h4>Statement - last year</h4>
              <table mat-table matSort [dataSource]="card.financialStatements" class="mat-elevation-z8" style="width: 100%;">

                <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

                <ng-container matColumnDef="direction">
                  <th mat-header-cell *matHeaderCellDef style="width: 25px;"></th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.type === 'A' && element.statusCode === 'A'">⌛️</ng-container>
                    <ng-container *ngIf="element.type === 'D' && element.statusCode === 'A'">↩️️</ng-container>
                    <ng-container *ngIf="element.type === 'L'">💰</ng-container>
                    <ng-container *ngIf="element.type === 'U'">💸</ng-container>
                    <ng-container *ngIf="element.type === 'P' && element.statusCode === 'S'">✅</ng-container>
                    <ng-container *ngIf="element.type === 'B' && element.isCredit">🔼</ng-container>
                    <ng-container *ngIf="element.type === 'B' && !element.isCredit">🔽</ng-container>
                    <ng-container *ngIf="element.statusCode === 'I'">⛔️</ng-container>

                  </td>
                </ng-container>

                <ng-container matColumnDef="transactionDate">
                  <th mat-header-cell *matHeaderCellDef style="width: 100px;">Date</th>
                  <td mat-cell *matCellDef="let element"> {{ element.transactionDate | date:'dd.MM.yyyy'}} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef style=""> Description </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="txn-description">{{element.description}}</div>
                    <div *ngIf="element.note" style="font-size: .9em; font-family: monospace;" [class]="'statement-note-' + element.statusCode">
                      📝 {{element.note}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Amt. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <div [class]="'amount-' + element.statusCode">
                      {{element.amount.toFixed(2)}}
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="blockAmount">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Blk. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <ng-container *ngIf="element.blockedAmount">
                      {{element.blockedAmount.toFixed(2)}}
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="billAmount">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Bill </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.billAmount.toFixed(2)}} </td>
                </ng-container>

                <ng-container matColumnDef="currency">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: center;"> Cur. </th>
                  <td mat-cell *matCellDef="let element" style=" text-align: center;"> {{element.currency}} </td>
                </ng-container>

                <ng-container matColumnDef="rateFee">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Rate f. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <ng-container *ngIf="element.rateFee">
                      {{element.rateFee.toFixed(2)}}
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="fixedFee">
                  <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Fixed f. </th>
                  <td mat-cell *matCellDef="let element" style="text-align: right;">
                    <ng-container *ngIf="element.fixedFee">
                      {{element.fixedFee.toFixed(2)}}
                    </ng-container>
                  </td>
                </ng-container>


                <ng-container matColumnDef="statusDescription">
                  <th mat-header-cell *matHeaderCellDef style="width: 80px;  text-align: center;"> Status </th>
                  <td mat-cell *matCellDef="let element" style=" text-align: right;">
                    <div [class]="'status-' + element.statusCode">
                      {{ element.statusDescription }}
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedStatementColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedStatementColumns;" class="txn-row"></tr>
              </table>
            </div>

            <div [hidden]="!isCardholderDetailsLoading" style="margin-top: 10px;">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="card.cardholderDetails">
              <h4>Cardholder details</h4>
              <div mat-dialog-content>
                <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCardholderDetails ">
                  <label fxFlex="35" class="secondary">{{ field.header }}</label>
                  <label fxFlex="65" *ngIf="card.cardholderDetails">{{ field.cell(card.cardholderDetails) }}</label>
                </div>
              </div>
            </div>

            <div [hidden]="!isCardInfoLoading" style="margin-top: 10px;">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="card.cardInfo">
              <h4>Card infos</h4>
              <div mat-dialog-content>
                <div class="list-item" fxLayout="row" *ngFor="let field of fieldsCardInfo ">
                  <label fxFlex="35" class="secondary">{{ field.header }}</label>
                  <label fxFlex="65" *ngIf="card.cardInfo">{{ field.cell(card.cardInfo) }}</label>
                </div>
              </div>
            </div>

          </mat-expansion-panel>




        </mat-card-content>
      </mat-card>
    </div>

  </div>

</div>


<mat-card class="content-card">

  <mat-card-header>
    <mat-card-title>
      <h5>📊 Load & Limit Graph</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <i>Future Amounts are a projection based on the current card limits and limits defined by the card holder's ident level</i>

<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" >

  <div fxFlex="100" style="padding: 15px; vertical-align: middle;">

    <div style="width: 100%; overflow: scroll;">
      <ngx-charts-bar-vertical-2d
              [view]="view"
              [scheme]="colorScheme"
              [results]="multi"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [animations]="animations"
              [barPadding]="barPadding"
              [groupPadding]="1"
              [customColors]="barCustomColors"

              (select)="onSelectGraph($event)"


      >
      </ngx-charts-bar-vertical-2d>
    </div>

  </div>
</div>
  </mat-card-content>
</mat-card>
